import * as React from 'react';

import { getProductsByIdBatched } from '@components/Universals/BatchVPProductQuery/queries/__generated__/getProductsByIdBatched';

import { useNewPdDesignEnabled } from '../hooks/useNewPdDesignEnabled';

import { ProductsSectionContent } from './ProductSectionContent';
import { StyledListPlaceholder } from './styled';

interface IProductListContentParams {
  loading: boolean;
  listLabel: string;
  inView: boolean;
  data: getProductsByIdBatched;
  trackProductClick: boolean;
  trackProductImpression: boolean;
}

export const ProductListContent = ({
  loading,
  listLabel,
  inView,
  data,
  trackProductClick,
  trackProductImpression,
}: IProductListContentParams) => {
  const newDesign = useNewPdDesignEnabled();
  if (inView && !loading) {
    return (
      <ProductsSectionContent
        data={data}
        listLabel={listLabel}
        trackProductClick={trackProductClick}
        trackProductImpression={trackProductImpression}
      />
    );
  }
  return (
    <StyledListPlaceholder
      id={listLabel}
      placeholderCount={4}
      rows={4}
      newDesign={newDesign}
      containerProps={{
        ['data-testid']: 'product-items-placeholder',
      }}
    />
  );
};
